import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useT } from "../i18n";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { LOGO_URL } from "../components/Reveal";
import { Input } from "../components/ui/input";
import { Field } from "./Login";
import { toast } from "sonner";

const HERO = "https://images.unsplash.com/photo-1602075030798-173d12cd400a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const Register = () => {
  const { t } = useT();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      toast.success(t("auth.register_success"));
      navigate("/espace");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 relative z-10">
      <div className="flex items-center justify-center p-6 sm:p-12 bg-background order-2 lg:order-1">
        <div className="w-full max-w-md">
          <Link to="/"><img src={LOGO_URL} alt="YADIMMO" className="h-9 mb-10" /></Link>
          <h1 className="font-display text-3xl text-navy font-light mb-8">{t("auth.register_title")}</h1>

          {error && <div data-testid="register-error" className="mb-4 text-sm text-destructive bg-destructive/10 border border-destructive/20 px-4 py-3">{error}</div>}

          <form data-testid="register-form" onSubmit={submit} className="space-y-4">
            <Field label={t("auth.name")}><Input data-testid="register-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-12 rounded-lg border-navy/15" /></Field>
            <Field label={t("auth.email")}><Input data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-12 rounded-lg border-navy/15" /></Field>
            <Field label={t("auth.phone")}><Input data-testid="register-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="h-12 rounded-lg border-navy/15" /></Field>
            <Field label={t("auth.password")}><Input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="h-12 rounded-lg border-navy/15" /></Field>
            <button data-testid="register-submit" disabled={loading} className="w-full bg-navy text-white font-semibold py-4 rounded-full hover:bg-[#254B75] transition-colors disabled:opacity-60">
              {loading ? t("common.loading") : t("auth.register_btn")}
            </button>
          </form>

          <p className="mt-6 text-sm text-muted-foreground">
            {t("auth.have_account")} <Link to="/connexion" data-testid="link-login" className="text-navy font-semibold hover:text-gold">{t("nav.login")}</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={HERO} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-navy/60" />
      </div>
    </div>
  );
};

export default Register;
